import {h, Fragment} from "preact"
import { useFacets, useSelectedFiltersCount } from "@nosto/preact"
import Facet from "./Facet"
import RangeFacet from "./RangeFacet"
import SelectedFilters from "./SelectedFilters"
import Icon from "./elements/Icon"
import { useState } from "preact/hooks"

export const toggleButtonId = "toggle-mobile-sidebar"

function ToggleSidebarButton({ className }) {
    return (
        <label
            className={`ns-act-btn ns-close-sidebar ns-absolute ns-d-block ns-d-md-none ns-text-align-right ns-align-items-center ns-clickable ${className}`}
            for={toggleButtonId}
        >
            <Icon name="close" />
        </label>
    )
}

function OpenSidebar({ selectedFiltersCount, sidebarOpen, setSidebarOpen }) {
    return (
        <label
            for={toggleButtonId}
            className="ns-filters ns-d-none ns-d-md-inline-flex ns-text-align-center ns-align-items-center toggle-btn utility-bar__item"
            onClick={() => setSidebarOpen(!sidebarOpen)}
        >
            <span class="button-icon">
                <svg width="23" height="19" viewBox="0 0 20 20" stroke-width="1.25" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <line x1="1" y1="6" x2="19" y2="6" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"></line>
                    <line x1="1" y1="14" x2="19" y2="14" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"></line>
                    <circle cx="7" cy="6" r="3" fill="none" stroke="currentColor"></circle>
                    <circle cx="13" cy="14" r="3" fill="none" stroke="currentColor"></circle>
                </svg>
            </span>
            <span>Filter</span>
            {selectedFiltersCount > 0 && (
                <span className="ns-total-count ns-ml-1">
                    ({selectedFiltersCount})
                </span>
            )}
        </label>
    )
}

export default function SideBar() {
    const { loading, facets } = useFacets()
    const [ sidebarOpen, setSidebarOpen ] = useState(true)
    const selectedFiltersCount = useSelectedFiltersCount()

    return facets?.length > 0 ? (
        <>
            <input type="checkbox" id={toggleButtonId} class="ns-facet-sidebar-toggle ns-d-none" />
            <label
                class="ns-sidebar-backdrop ns-fixed ns-w-100 ns-h-100 ns-background-black ns-d-none"
                for={toggleButtonId}
            />
            <div class="ns-sidebar-wrapper ns-d-none ns-d-md-block ns-h-100">
                <div class="ns-sidebar-content ns-relative ns-background-white ns-h-100 ns-mr-0 ns-mr-md-auto">
                    <div class="ns-sidebar-header ns-d-flex ns-align-items-baseline">
                        <div class="filters__heading ns-d-block ns-d-md-none">
                            <h4 class="filters__heading-text">Filter</h4>
                        </div>
                        <OpenSidebar 
                            setSidebarOpen={setSidebarOpen} 
                            sidebarOpen={sidebarOpen} 
                            selectedFiltersCount={selectedFiltersCount} 
                        />
                        <ToggleSidebarButton />
                    </div>
                    <SelectedFilters />
                    <div class={`ns-sidebar-menu ${sidebarOpen ? '' : 'ns-d-md-none'}`}>
                        <ul class="ns-list-unstyled ns-p-0 ns-m-0">
                            {facets?.map(facet => {
                                switch (facet.type) {
                                    case "terms":
                                        return <Facet key={facet.id} facet={facet} />
                                    case "stats":
                                        return <RangeFacet key={facet.id} facet={facet} />
                                    default:
                                        return null
                                }
                            })}
                        </ul>
                    </div>
                </div>
            </div>
        </>
    ) : (
        ""
    )
}
